import { storeToRefs } from "pinia";
import { computed } from "vue";

import { useCurrentUserStore } from "@/stores/current-user/current-user-store";
import { isOperator } from "@/utils/env-feature-flag/env-feature-flag-user-bypass";

export function useUserPermission() {
  const currentUserStore = useCurrentUserStore();
  const { currentUser } = storeToRefs(currentUserStore);

  const isCurrentUserOperator = computed<boolean>(() => {
    if (!currentUser.value) return false;
    return isOperator(currentUser.value);
  });

  return {
    isCurrentUserOperator,
  };
}
